import Vue from 'vue'

import AFTableColumn from './AFTable'

// 导入需要被全局注册的组件
const globalComponents = [
  AFTableColumn,
]

globalComponents.install = () => {
  globalComponents.map((component) => {
    Vue.component(component.name, component)
  })
}

export default globalComponents


// WEBPACK FOOTER //
// ./src/components/common/AFTableColumn/index.js